<template>
  <el-button @click="onClick">{{widget.label}}</el-button>
</template>

<script>
import EventBus from '@/assets/EventBus.js';

export default {
    name: 'AssignToWorkflowButton',

    props: ['widget'],

    methods: {
        onClick() {
            EventBus.$emit('show-start-form', this.widget.parameter);
        }
    },

    mounted() {
        console.log('#12 AssignToWorkflowButton', this.widget, this);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/AssignToWorkflowButton.vue